<template>
  <div class="home_page">
    <Tabbar :title="$t('basicLevel.cashOut')" :back="onBack"></Tabbar>
    <div class="balance_des_menu">
      <div class="withdraw_account"></div>
      <div class="balance_des_item" @click="showPopup">
        <div class="balance_title" :class="[$store.state.isMirroring && 'ta-r']">
          {{ $t('withdrawAccount.withdrawTo') }}
        </div>
        <div class="sb-s item_content">
          <div v-if="selectWithdrawMethod && withdrawTypeClassName[selectWithdrawMethod.withdrawType]" class="flex">
            <div class="balance_des_item_hd_img">
              <img
                v-if="getChannelIcon(selectWithdrawMethod.withdrawType)"
                class="channel_icon"
                :src="getChannelIcon(selectWithdrawMethod.withdrawType)"
                alt=""
              />
              <i v-else :class="withdrawTypeClassName[selectWithdrawMethod.withdrawType]"></i>
            </div>
            <div class="select_text">
              <span :class="[$store.state.isMirroring && 'ta-r']">
                {{ withdrawType[selectWithdrawMethod.withdrawType] }}
              </span>
              <span class="select_text_account">{{ formatAccount(this.selectWithdrawMethod.account) }}</span>
            </div>
          </div>
          <div v-else class="no_available_note">
            {{ $t('withdrawAccount.noAvailableMethodNote') }}
          </div>
          <img
            class="balance_des_item_ft_img"
            :class="[$store.state.isMirroring && 'mirror']"
            src="../assets/arrow_right.png"
          />
        </div>
      </div>
      <div class="balance_des_item">
        <div class="balance_title border_none" :class="[$store.state.isMirroring && 'ta-r']">
          {{ $t('withdrawAccount.withdrawAmount') }}
        </div>
        <div
          class="input_amount_wrapper"
          :class="{ focused: show }"
          @touchstart.stop="openAmountKeyboard"
          @click="openAmountKeyboard"
        >
          <span class="amount_currency">$</span>
          <span v-if="formatAmount" class="amount_value">{{ formatAmount }}</span>
          <span v-else-if="!show" class="amount_placeholder">{{
            $t('withdrawAccount.availableBalance', [format(this.$store.state.balance)])
          }}</span>
          <span v-if="show" class="amount_caret"></span>
          <img
            v-if="formatAmount"
            class="clear"
            src="../assets/close_icon.png"
            @touchstart.stop="amount = ''"
            @click.stop="amount = ''"
          />
        </div>
        <van-number-keyboard
          v-model="formatAmount"
          :show="show"
          theme="custom"
          :close-button-text="$t('common.confirm')"
          @blur="closeAmountKeyboard"
        />
        <div class="Withdrawable sb-s">
          <span>{{ $t('withdrawAccount.withdrawable') }} {{ format(this.$store.state.balance) }}</span>
          <span class="balance_des_item_span_all" @click="setAmount">{{ $t('home.all') }}</span>
        </div>
      </div>
      <div class="balance_des_item fee">
        <span class="balance_des_item_hd">{{ $t('transfer.fee') }}</span>
        <span class="balance_des_item_span">{{ estimatedFee }}</span>
      </div>
      <div
        v-if="selectWithdrawMethod && selectWithdrawMethod.withdrawType === 3 && $store.state.userInfo.countryNo == 186"
        class="balance_des_tip"
        :class="[$store.state.isMirroring && 'ta-r']"
      >
        {{ $t('withdrawAccount.amountLimitToast1') }}
      </div>
      <div
        v-else-if="$t('withdrawAccount.amountLimitToast2', [amountNeedValue]) !== amountErr"
        class="balance_des_tip"
        :class="[$store.state.isMirroring && 'ta-r']"
      >
        {{ $t('withdrawAccount.amountLimitToast2', [amountNeedValue]) }}
      </div>
      <!-- 提现输入框校验提示文案 -->
      <div v-if="amountErr" class="balance_err_text">{{ amountErr }}</div>
      <div v-if="recommendAmount > 0" class="balance_des_tip" :class="[$store.state.isMirroring && 'ta-r']">
        {{ $t('withdrawAccount.recommendAmountNote', [recommendAmount]) }}
      </div>
      <CommonBtn
        class="next_btn"
        :text="$t('common.submit')"
        :disabled="!!amountErr || !amount"
        :on-click="withdrawSubmit"
      />
    </div>
    <van-popup
      v-model="popupShow"
      position="bottom"
      class="account_picker_popup"
      :style="{ maxHeight: popHeight + 'px' }"
    >
      <div class="account_popup">
        <div class="title_wrapper" :class="[$store.state.isMirroring && 'title_mirror']">
          <div class="title_text">{{ $t('account.linkedAccount') }}</div>
          <router-link
            :to="{ name: 'MyLinkedAccount', query: { redirect: 'Withdrawal' } }"
            class="add_btn"
            :class="[$store.state.isMirroring && 'add_mirror']"
          >
            <span>{{ $t('withdrawAccount.add') }}</span>
          </router-link>
        </div>
        <div class="account_popup_scroll">
        <div class="linked_wrapper" v-if="pickerWithdrawMethods.length > 0">
          <div class="link_title" :class="[$store.state.isMirroring && 'ta-r']">
            {{ $t('withdrawAccount.linkedAccount') }}
          </div>
          <div
            class="item_content sb-s"
            v-for="item in pickerWithdrawMethods"
            :key="item.account"
            @click="setSelectWithdrawMethod(item)"
          >
            <div class="flex">
              <div class="select_account_logo">
                <img
                  v-if="getChannelIcon(item.withdrawType)"
                  class="channel_icon"
                  :src="getChannelIcon(item.withdrawType)"
                  alt=""
                />
                <i v-else :class="withdrawTypeClassName[item.withdrawType]"></i>
              </div>
              <div>
                <div class="account_info">
                  <div :class="[$store.state.isMirroring && 'ta-r']">{{ withdrawType[item.withdrawType] }}</div>
                  <div class="account">{{ formatAccount(item.account) }}</div>
                </div>
              </div>
            </div>
            <div>
              <!-- 仅有效的提现方式可展示选中图标 -->
              <img
                v-show="
                  selectWithdrawMethod &&
                  selectWithdrawMethod.account === item.account &&
                  selectWithdrawMethod.withdrawType === item.withdrawType &&
                  !isDisabledWithdrawMethods(item.withdrawType)
                "
                class="checkbox_label"
                :class="[$store.state.isMirroring && 'check_mirror']"
                src="@/assets/icon_check_select_green.png"
              />
            </div>
          </div>
        </div>
        <div class="linked_wrapper" v-if="pickerWithdrawTypeConfigs.length > 0">
          <div class="link_title" :class="[$store.state.isMirroring && 'ta-r']">
            {{ $t('withdrawAccount.otherAccounts') }}
          </div>
          <div v-for="item in pickerWithdrawTypeConfigs" :key="item.withdrawType">
            <div class="item_content sb-c">
              <div class="flex">
                <div class="select_account_logo">
                  <img
                    v-if="getChannelIcon(item.withdrawType)"
                    class="channel_icon"
                    :src="getChannelIcon(item.withdrawType)"
                    alt=""
                  />
                  <i v-else :class="withdrawTypeClassName[item.withdrawType]"></i>
                </div>
                <div>
                  <div class="account_info">
                    <div>{{ withdrawType[item.withdrawType] }}</div>
                    <div class="account">{{ formatChannelFee(item.withdrawType) }}</div>
                  </div>
                </div>
              </div>
              <div>
                <div class="edit_btn" @click="goToBindAccount(item.withdrawType)">{{ $t('common.bind') }}</div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </van-popup>
    <CheckPayPassword :show="payPasswordShow" v-bind:on-success="onPasswordSuccess" v-bind:on-close="onClose" />
    <van-popup
      v-model="channelUnavailableShow"
      position="bottom"
      get-container="#app"
      class="channel_unavailable_popup"
      :overlay-style="{ background: 'rgba(47, 47, 47, 0.25)', zIndex: 3999 }"
    >
      <div class="channel_unavailable_card">
        <div class="channel_unavailable_texts">
          <div class="channel_unavailable_title">{{ $t('withdrawAccount.channelUnavailableTitle') }}</div>
          <div class="channel_unavailable_note">{{ $t('withdrawAccount.channelUnavailableNote') }}</div>
        </div>
        <div class="channel_unavailable_ok" @click="onChannelUnavailableOk">
          {{ $t('withdrawAccount.channelUnavailableOk') }}
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="bankTransferUnavailableShow"
      position="bottom"
      get-container="#app"
      class="channel_unavailable_popup"
      :overlay-style="{ background: 'rgba(47, 47, 47, 0.25)', zIndex: 3999 }"
    >
      <div class="channel_unavailable_card">
        <div class="channel_unavailable_texts">
          <div class="channel_unavailable_title">{{ $t('withdrawAccount.bankTransferUnavailableTitle') }}</div>
          <div class="channel_unavailable_note">{{ $t('withdrawAccount.bankTransferUnavailableNote') }}</div>
        </div>
        <div
          class="channel_unavailable_ok"
          @click="onBankTransferUnavailableAction"
        >
          {{ boundEpayMethod ? $t('withdrawAccount.useEpay') : $t('withdrawAccount.bindEpay') }}
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="channelMaintenanceShow"
      position="bottom"
      get-container="#app"
      class="channel_unavailable_popup"
      :overlay-style="{ background: 'rgba(47, 47, 47, 0.25)', zIndex: 3999 }"
    >
      <div class="channel_unavailable_card">
        <div class="channel_unavailable_texts">
          <div class="channel_unavailable_title">{{ $t('withdrawAccount.channelMaintenanceTitle') }}</div>
          <div class="channel_unavailable_note">{{ $t('withdrawAccount.channelMaintenanceNote') }}</div>
        </div>
        <div class="channel_unavailable_ok" @click="onChannelMaintenanceOk">
          {{ $t('withdrawAccount.channelUnavailableOk') }}
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="bankInfoUpdateShow"
      position="bottom"
      get-container="#app"
      class="channel_unavailable_popup"
      :overlay-style="{ background: 'rgba(47, 47, 47, 0.25)', zIndex: 3999 }"
    >
      <div class="channel_unavailable_card">
        <div class="channel_unavailable_texts">
          <div class="channel_unavailable_title">{{ $t('withdrawAccount.bankInfoUpdateTitle') }}</div>
          <div class="channel_unavailable_note">{{ $t('withdrawAccount.bankInfoUpdateNote') }}</div>
        </div>
        <div class="channel_unavailable_ok" @click="onBankInfoUpdateOk">
          {{ $t('withdrawAccount.channelUnavailableOk') }}
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="loadingShow"
      get-container="#app"
      style="background: transparent; overflow: hidden"
    >
      <van-loading type="spinner" color="#378E5B" />
    </van-popup>
    <PopWindow
      v-if="popShow"
      :content="popContent"
      :cancel="cancelBtn"
      :cancelShow="cancelShow"
      class="pop_window"
      @closePop="closePop"
      :btn="popBtn"
    ></PopWindow>
    <PaymentCodeSetPopup v-model="showPaymentCodeSetPopup" :hasOldPaymentCode="hasPaymentCode" />
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import CheckPayPassword from '@/components/CheckPayPassword'
import Vue from 'vue'
import Vant, { Toast, Dialog, Loading, Popup } from 'vant'
import PopWindow from '@/components/PopWindow'
import { withdrawType } from '@/utils/enum.js'
import { getChannelIcon } from '@/utils/channelIcons'
import CommonBtn from '@/components/CommonBtn.vue'
import PaymentCodeSetPopup from '@/components/PaymentCode/PaymentCodeSetPopup.vue'
import { spendableCents } from '@/utils'
import { getWithdrawDurationExtra, markWithdrawPageStart, postReportLog } from '../utils/log'
import interceptSystemBack from '@/mixins/interceptSystemBack'

Vue.use(Vant)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Popup)

export default {
  name: 'Withdrawal',
  mixins: [interceptSystemBack],
  data() {
    return {
      withdrawType,
      amount: '',
      amountErr: null,
      amountNeedValue: '10',
      show: false,
      popupShow: false,
      hiddenWithdrawTypes: [],
      filterUnavailableInPicker: false,
      unavailableWithdrawType: null,
      channelUnavailableShow: false,
      bankTransferUnavailableShow: false,
      channelMaintenanceShow: false,
      bankInfoUpdateShow: false,
      selectWithdrawMethod: {
        withdrawType: 0,
        account: ''
      },

      loadingShow: false,
      withdrawMethods: [],
      withdrawTypeConfigs: [],
      withdrawTypeClassName: [
        undefined,
        undefined,
        undefined,
        'icon_bank_card',
        'icon_gcash',
        'icon_paymaya',
        'icon_coins_ph',
        'icon_go_pay',
        'icon_ovo',
        'icon_dana',
        'icon_payapal',
        'icon_epay',
        'icon_e_wallet',
        'icon_qiwi',
        'usdt_epay',
        'new_icon_payapal',
        'new_icon_imps',
        'icon_upi',
        'icon_jazz_cash',
        'icon_easy_paisa',
        'new_icon_payapal'
      ],
      withdrawConfig: [],
      payPasswordShow: false,
      arriPayFee: undefined,
      rate: undefined,
      ratio: undefined,
      minFee: undefined,
      maxFee: undefined,
      fee: undefined,
      feeCurrency: undefined,
      countryNo: this.$store.state.userInfo.countryNo,
      popShow: false,
      popContent: '',
      cancelBtn: '',
      cancelShow: false,
      popBtn: '',
      ladderWalletFee: 0, // wallet阶梯手续费
      ladderFeeConfig: [], // 阶梯手续费配置
      recommendAmount: 0, // 推荐的提现金额
      showPaymentCodeSetPopup: false,
      hasPaymentCode: false,
      popHeight: 0,
      hasShowModifyDialog: sessionStorage.getItem('hasShowModifyDialog') || '',
      basicUpdateStatus: 0
    }
  },
  components: {
    Tabbar,
    CheckPayPassword,
    PopWindow,
    CommonBtn,
    PaymentCodeSetPopup
  },
  async created() {
    await this.getWithdrawConfig()
    this.getValidWithdrawMethods()
    this.getWithdrawTypeConfigs()
    // 重置store.state.balance 用户的金额为 20
  },
  mounted() {
    // 曝光埋点
    markWithdrawPageStart()
    postReportLog({
      log_id: '440',
      extra: {
        page: 'withdrawal'
      }
    })
    this.updatePopHeight()
    if (window.visualViewport && window.visualViewport.addEventListener) {
      this.onViewportResize = () => this.updatePopHeight()
      window.visualViewport.addEventListener('resize', this.onViewportResize)
    }
    this.getBasicUpdateStatus()
  },
  beforeDestroy() {
    if (window.visualViewport && this.onViewportResize) {
      window.visualViewport.removeEventListener('resize', this.onViewportResize)
    }
  },
  computed: {
    formatAmount: {
      get() {
        const value = this.amount
        const amount = Number(String(value).replace(/\.$/, ''))
        const balance = spendableCents(this.$store.state.balance) / 100
        if (value && amount < Number(this.amountNeedValue)) {
          this.amountErr = this.$t('withdrawAccount.amountLimitToast2', [this.amountNeedValue])
        } else if (value && amount > balance) {
          this.amountErr = this.$t('withdrawAccount.amountNotEnoughToast')
        } else if (value && amount > 260 && this.selectWithdrawMethod.withdrawType === 16) {
          // livPay，最大可提现金额不超过 260
          this.amountErr = this.$t('withdrawAccount.iMPSMaxLimitToast')
        } else {
          this.amountErr = null
        }
        // 计算推荐提现金额
        // 推荐用户提现金额为下一阶段的最小值，如果为最后一档则不显示推荐
        if (this.ladderFeeConfig.length > 0) {
          // 存在阶梯配置
          // 最大推荐值为最后一档最小值
          let maxLadderAmount = this.ladderFeeConfig[this.ladderFeeConfig.length - 1].amountMin
          if (amount > 0 && amount < maxLadderAmount) {
            this.ladderFeeConfig.forEach((item, index) => {
              // 计算输入值符合哪档
              if (amount >= item.amountMin && amount < item.amountMax) {
                // 计算推荐值
                this.recommendAmount = this.ladderFeeConfig[index + 1].amountMin
              }
            })
          } else {
            this.recommendAmount = 0
          }
        }
        return value
      },
      set(value) {
        const digits = String(value == null ? '' : value).replace(/\D/g, '')
        this.amount = digits.replace(/^0+(\d)/, '$1')
      }
    },
    estimatedFee() {
      const applyMaxFee = (fee) => (this.maxFee && this.maxFee !== 0 ? Math.min(fee, this.maxFee) : fee)
      if (this.amount) {
        // 计算阶段手续费
        if (this.ladderFeeConfig.length > 0) {
          let maxLadderAmount = this.ladderFeeConfig[this.ladderFeeConfig.length - 1].amountMin
          this.ladderFeeConfig.forEach((item, index) => {
            if (this.amount < maxLadderAmount) {
              // 计算输入值符合哪档
              if (this.amount >= item.amountMin && this.amount < item.amountMax) {
                // 该档位手续费
                if (this.amount < maxLadderAmount) {
                  this.ladderWalletFee = this.amount * (item.rate / 100) + item.feeFix
                }
              }
            } else {
              // 最后一档
              this.ladderWalletFee =
                this.amount * (this.ladderFeeConfig[this.ladderFeeConfig.length - 1].rate / 100) +
                this.ladderFeeConfig[this.ladderFeeConfig.length - 1].feeFix
            }
          })
        }
        //  固定手续费还是阶梯手续费
        const walletFee = this.ladderFeeConfig.length > 0 ? this.ladderWalletFee : this.arriPayFee
        if (this.selectWithdrawMethod.withdrawType === 16) {
          return new Intl.NumberFormat('en', {
            style: 'currency',
            currency: this.feeCurrency,
            currencyDisplay: 'symbol'
          }).format(applyMaxFee(this.amount * 0.03).toFixed(2))
        }
        if (this.selectWithdrawMethod.withdrawType === 14 && this.amount >= 100) {
          return new Intl.NumberFormat('en', {
            style: 'currency',
            currency: this.feeCurrency,
            currencyDisplay: 'symbol'
          }).format(2)
        }
        if (this.feeCurrency === 'USD') {
          let resFee = ((this.amount - walletFee) * this.ratio) / 100.0 + this.fee
          return new Intl.NumberFormat('en', {
            style: 'currency',
            currency: 'USD',
            currencyDisplay: 'symbol'
          }).format((walletFee + applyMaxFee(Math.max(resFee, this.minFee))).toFixed(2))
        } else if (this.feeCurrency) {
          let resFee = ((this.amount - walletFee) * this.rate * this.ratio) / 100.0 + this.fee
          return new Intl.NumberFormat('en', {
            style: 'currency',
            currency: this.feeCurrency,
            currencyDisplay: 'symbol'
          }).format((walletFee * this.rate + applyMaxFee(Math.max(resFee, this.minFee))).toFixed(2))
        }
      }
      return this.$t('withdrawAccount.estimatedFee')
    },
    // 可提现渠道
    enableWithdrawTypes() {
      return this.withdrawConfig.map((item) => item.withdrawType)
    },
    boundEpayMethod() {
      return (this.withdrawMethods || []).find((item) => item.withdrawType === 11)
    },
    pickerWithdrawMethods() {
      return (this.withdrawMethods || []).filter((item) => this.isPickerChannelVisible(item.withdrawType))
    },
    pickerWithdrawTypeConfigs() {
      return (this.withdrawTypeConfigs || []).filter((item) => this.isPickerChannelVisible(item.withdrawType))
    }
  },
  methods: {
    getChannelIcon,
    openAmountKeyboard() {
      this.show = true
      this.startBackTrap()
    },
    closeAmountKeyboard() {
      this.show = false
      this.stopBackTrap()
    },
    onSystemBack() {
      if (this.show) {
        this.show = false
        return false
      }
      return false
    },
    openPaymentCodeSetPopup(hasPaymentCode) {
      this.hasPaymentCode = hasPaymentCode
      this.showPaymentCodeSetPopup = true
    },
    onBack() {
      this.$router.replace({
        name: 'Home'
      })
    },
    showPopup() {
      this.hiddenWithdrawTypes = []
      this.filterUnavailableInPicker = false
      this.unavailableWithdrawType = null
      this.updatePopHeight()
      this.popupShow = true
    },
    updatePopHeight() {
      const viewport = window.visualViewport
      const height = (viewport && viewport.height) || window.innerHeight || 0
      this.popHeight = Math.floor(height * 0.8)
    },
    getValidWithdrawMethods() {
      // 获取可用的提现方式
      this.$http
        .get(window.serverPath + '/api/account/withdrawMethods')
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.withdrawMethods = res.data.data
            // 过滤出第一个可提现渠道，即手续费支持的渠道
            if (res.data.data instanceof Array) {
              let result = this.withdrawMethods.find((item) => this.enableWithdrawTypes.includes(item.withdrawType))
              this.selectWithdrawMethod = result
            }
            if (!this.selectWithdrawMethod) {
              return
            }
            this.getWithdrawTypeConfigOne(this.selectWithdrawMethod.withdrawType)
            if (
              this.countryNo === 48 ||
              this.countryNo === 54 ||
              this.countryNo === 89 ||
              this.countryNo === 150 ||
              this.countryNo === 160 ||
              this.countryNo === 193 ||
              this.countryNo === 199
            ) {
              this.amountNeedValue = 20
            } else if (this.selectWithdrawMethod.withdrawType === 3 && this.$store.state.userInfo.countryNo === 186) {
              this.amountNeedValue = 40
            } else {
              this.amountNeedValue = 10
            }
          }
          this.getExtWithdrawConfig()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取阶梯手续费
    getExtWithdrawConfig() {
      this.$http
        .get(
          window.serverPath +
            `/api/withdraw/config/ext/info?countryNo=${this.$store.state.userInfo.countryNo}&withdrawType=${this.selectWithdrawMethod.withdrawType}&bankType=${this.selectWithdrawMethod.bankType}`
        )
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.ladderFeeConfig = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取手续费
    async getWithdrawConfig() {
      await this.$http
        .get(window.serverPath + '/api/withdraw/config/info?countryNo=' + this.$store.state.userInfo.countryNo)
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.withdrawConfig = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getWithdrawTypeConfigOne(withdrawType) {
      let findIndex = -1
      for (let i = 0; i < this.withdrawConfig.length; i++) {
        if (parseInt(this.withdrawConfig[i].withdrawType) === withdrawType) {
          findIndex = i
        }
      }
      if (findIndex === -1) return
      let result = this.withdrawConfig[findIndex]
      this.arriPayFee = result.arriPayFee
      this.rate = result.rate
      this.ratio = result.ratio
      this.minFee = result.minFee
      this.maxFee = result.maxFee
      this.fee = result.fee
      this.feeCurrency = result.feeCurrency
    },
    // 判断提现渠道是否可用
    isDisabledWithdrawMethods(withdrawType) {
      let isDisabled = true
      this.withdrawConfig.forEach((item) => {
        if (item.withdrawType === withdrawType) {
          isDisabled = false
        }
      })
      return isDisabled
    },
    isPickerChannelVisible(withdrawType) {
      if (this.hiddenWithdrawTypes.indexOf(withdrawType) !== -1) return false
      if (this.filterUnavailableInPicker && this.isDisabledWithdrawMethods(withdrawType)) return false
      return true
    },
    setAmount() {
      const dollars = Math.floor(spendableCents(this.$store.state.balance) / 100)
      this.amount = dollars > 0 ? String(dollars) : ''
    },
    format(value) {
      if (typeof value !== 'number') {
        value = parseFloat(value)
      }
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: 'symbol'
      }).format(spendableCents(value) / 100)
    },
    formatAccount(account) {
      if (account) {
        const len = account.length
        if (len > 8) {
          return account.substr(0, 4) + '****' + account.substr(len - 4, len)
        } else if (len > 4) {
          return account.substr(0, 2) + '***' + account.substr(len - 2, len)
        }

        return account
      }

      return account
    },
    formatChannelFee(type) {
      if (type === 16) {
        return this.$t('withdrawAccount.channelFee', ['3%'])
      }
      if (type === 14) {
        return this.$t('withdrawAccount.usdtFee')
      }
      const config = this.withdrawConfig.find((item) => parseInt(item.withdrawType) === type)
      if (!config || config.ratio === undefined || config.ratio === null || config.ratio === '') {
        return ''
      }
      return this.$t('withdrawAccount.channelFee', [`${config.ratio}%`])
    },
    setSelectWithdrawMethod(value) {
      const isDisabled = this.isDisabledWithdrawMethods(value.withdrawType)
      if (isDisabled) {
        this.unavailableWithdrawType = value.withdrawType
        this.channelUnavailableShow = true
        return
      }
      this.selectWithdrawMethod = value
      if (
        this.countryNo === 48 ||
        this.countryNo === 54 ||
        this.countryNo === 89 ||
        this.countryNo === 150 ||
        this.countryNo === 160 ||
        this.countryNo === 193 ||
        this.countryNo === 199
      ) {
        this.amountNeedValue = 20
      } else if (this.selectWithdrawMethod.withdrawType === 3 && this.$store.state.userInfo.countryNo === 186) {
        this.amountNeedValue = 40
      } else {
        this.amountNeedValue = 10
      }
      this.popupShow = false
      this.getExtWithdrawConfig()
      if (!this.selectWithdrawMethod.withdrawType) return
      this.getWithdrawTypeConfigOne(this.selectWithdrawMethod.withdrawType)
    },
    hasPayPassword() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(window.serverPath + '/api/auth/hasPayPassword')
          .then((res) => {
            if (res.data && res.data.code === '200') {
              if (res.data.data) {
                resolve(true)
              } else {
                // 未设置支付密码
                resolve(false)
              }
            }
            // 接口返回异常
            reject(new Error('Request failed!'))
          })
          .catch((err) => reject(err))
      })
    },
    onPasswordSuccess(value) {
      this.loadingShow = true
      this.payPasswordShow = false
      this.withdraw(value)
    },
    onClose() {
      this.payPasswordShow = false
    },
    closePop() {
      this.popShow = false
    },
    releaseWithdrawLayers() {
      this.loadingShow = false
      this.payPasswordShow = false
    },
    afterWithdrawLayersReleased(callback) {
      this.releaseWithdrawLayers()
      this.$nextTick(callback)
    },
    reportWithdrawSubmit() {
      postReportLog({
        log_id: '478',
        extra: {
          step: '4',
          action: 'withdraw_submit',
          amount: this.amount,
          withdraw_type:
            (this.selectWithdrawMethod && this.selectWithdrawMethod.withdrawType) || ''
        }
      })
    },
    reportWithdrawResult(result, errorCode) {
      postReportLog({
        log_id: '478',
        extra: {
          step: '5',
          action: 'withdraw_result',
          result,
          error_code: errorCode || '',
          amount: this.amount,
          withdraw_type:
            (this.selectWithdrawMethod && this.selectWithdrawMethod.withdrawType) || '',
          ...getWithdrawDurationExtra()
        }
      })
    },
    applyWithdrawFailResult(code, message) {
      if (code === '60600') {
        this.afterWithdrawLayersReleased(() => {
          Toast({
            message: this.$t('withdrawAccount.exceedingLimitToast1')
          })
        })
        return
      }
      if (code === '60601') {
        this.afterWithdrawLayersReleased(() => {
          Dialog.confirm({
            message: this.$t('withdrawAccount.exceedingLimitToast2'),
            confirmButtonText: this.$t('common.confirm'),
            cancelButtonText: this.$t('common.cancel')
          }).then(() => {
            this.$router.push({ name: 'FullyVerified' })
          })
        })
        return
      }
      if (code === '602') {
        this.afterWithdrawLayersReleased(() => {
          Toast({
            message: this.$t('withdrawAccount.restrictedCountriesPayPalAccountToast')
          })
        })
        return
      }
      if (code === '61402') {
        this.afterWithdrawLayersReleased(() => {
          Toast({ message: this.$t('withdrawAccount.withdrawMinimumToast') })
        })
        return
      }
      if (code === '40011') {
        this.afterWithdrawLayersReleased(() => {
          this.channelMaintenanceShow = true
        })
        return
      }
      if (code === '40206') {
        this.afterWithdrawLayersReleased(() => {
          this.bankInfoUpdateShow = true
        })
        return
      }
      if (code === '40207') {
        this.afterWithdrawLayersReleased(() => {
          this.popContent = this.$t('withdrawAccount.usdtAccountInvalidToast')
          this.cancelShow = true
          this.cancelBtn = 'OK'
          this.popShow = true
        })
        return
      }
      if (code === '40209') {
        this.afterWithdrawLayersReleased(() => {
          this.popBtn = 'OK'
          this.popShow = true
          this.popContent = message
        })
        return
      }
      if (code === '40012') {
        this.afterWithdrawLayersReleased(() => {
          this.bankTransferUnavailableShow = true
        })
        return
      }
      if (code === '61403' || code === '10015' || code === '10016' || code === '100023') {
        this.afterWithdrawLayersReleased(() => {
          Toast(message)
        })
        return
      }
      this.afterWithdrawLayersReleased(() => {
        Toast({ message: this.$t('withdrawAccount.submitFailToast') })
      })
    },
    withdraw(value) {
      // 调用提现的接口
      const data = {
        ...this.selectWithdrawMethod,
        ...value,
        amount: this.amount
      }
      delete data.account
      delete data.userId
      this.$http
        .post(window.serverPath + '/api/account/withdraw', data)
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.reportWithdrawResult('success', '200')
            this.$router.push({
              name: 'WithdrawalResult',
              query: { amount: this.amount }
            })
            return
          }
          const code = (res.data && res.data.code) || 'unknown'
          const message = (res.data && res.data.message) || ''
          this.reportWithdrawResult('fail', code)
          this.applyWithdrawFailResult(code, message)
        })
        .catch((_err) => {
          this.reportWithdrawResult('fail', 'network')
          this.applyWithdrawFailResult('network')
        })
    },
    getBasicUpdateStatus() {
      this.$http.get(window.serverPath + '/api/user/getBasicUpdateStatus').then((res) => {
        if (res.data.code === '200') {
          this.basicUpdateStatus = res.data.data
        }
      })
    },
    withdrawSubmit() {
      if (!this.amountErr && this.amount) {
        if (this.basicUpdateStatus === 1 && !this.hasShowModifyDialog) {
          this.hasShowModifyDialog = '1'
          sessionStorage.setItem('hasShowModifyDialog', '1')
          Dialog.confirm({
            title: this.$t('basicLevel.checkDialogTitle'),
            message: this.$t('basicLevel.checkDialogContent'),
            cancelButtonText: this.$t('common.cancel'),
            confirmButtonText: this.$t('basicLevel.check')
          }).then(() => {
            this.$router.push({ name: 'EditBasicLevel' })
          })
          return
        }
        this.reportWithdrawSubmit()
        this.closeAmountKeyboard()
        // 检查支付密码是否存在
        this.hasPayPassword()
          .then((res) => {
            if (res) {
              // 支付密码存在，校验支付密码
              this.payPasswordShow = true
            } else {
              // 未设置支付密码
              Dialog.confirm({
                message: this.$t('withdrawAccount.noPayPwdToast'),
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel')
              }).then(() => {
                // on confirm
                this.openPaymentCodeSetPopup(false)
              })
            }
          })
          .catch((err) => {
            Toast({ message: err })
          })
      }
    },
    getWithdrawTypeConfigs() {
      this.$http
        .get(window.serverPath + '/api/account/withdrawTypeConfigs')
        .then((res) => {
          if (res.data && res.data.code === '200') {
            const type3Items = res.data.data.filter((item) => item.withdrawType === 3)
            const otherItems = res.data.data.filter((item) => item.withdrawType !== 3)
            this.withdrawTypeConfigs = type3Items.concat(otherItems)
          }
        })
        .catch((err) => console.log(err))
    },
    goToBindAccount(withdrawType) {
      console.log(withdrawType, 'withdrawType')
      if (this.$store.state.userInfo.level === 0) {
        Dialog.alert({
          message: this.$t('withdrawAccount.noBasicLevelVerificationDialog'),
          confirmButtonText: this.$t('common.confirm')
        }).then(() => {
          this.$router.push({
            name: 'BasicLevel',
            query: { ...this.$route.query }
          })
        })
        return
      }
      let name = ''
      switch (withdrawType) {
        case 3:
          name = 'BindBankAccount'
          break
        case 4:
          name = 'BindGcashAccount'
          break
        case 7:
          name = 'BindGoPayAccount'
          break
        case 8:
          name = 'BindOVOAccount'
          break
        case 9:
          name = 'BindDANAAccount'
          break
        case 10:
          name = 'BindPayPalAccount'
          break
        case 11:
          name = 'BindEPayAccount'
          break
        case 12:
          name = 'BindEWalletAccount'
          break
        case 13:
          name = 'BindQiwiAccount'
          break
        case 14:
          name = 'BindUSDTAccount'
          break
        case 15:
          name = 'BindNewPayPal'
          break
        case 16:
          name = 'BindNewIMPS'
          break
        case 17:
          name = 'BindUPIAccount'
          break
        case 18:
          name = 'BindJazzCash'
          break
        case 19:
          name = 'BindEasyPaisa'
          break
        case 20:
          name = 'BindPayoutPayPal'
          break
        default:
          break
      }
      console.log({ name, query: { ...this.$route.query } })
      this.$router.push({ name, query: { ...this.$route.query, redirect: 'Withdrawal' } })
    },
    onBankTransferUnavailableAction() {
      this.bankTransferUnavailableShow = false
      if (this.boundEpayMethod) {
        this.setSelectWithdrawMethod(this.boundEpayMethod)
        return
      }
      this.goToBindAccount(11)
    },
    onChannelUnavailableOk() {
      this.channelUnavailableShow = false
      this.filterUnavailableInPicker = true
      if (this.unavailableWithdrawType != null && this.hiddenWithdrawTypes.indexOf(this.unavailableWithdrawType) === -1) {
        this.hiddenWithdrawTypes = this.hiddenWithdrawTypes.concat([this.unavailableWithdrawType])
      }
    },
    onChannelMaintenanceOk() {
      this.channelMaintenanceShow = false
      const failedType = this.selectWithdrawMethod && this.selectWithdrawMethod.withdrawType
      this.hiddenWithdrawTypes = failedType != null ? [failedType] : []
      this.filterUnavailableInPicker = true
      this.$nextTick(() => {
        this.updatePopHeight()
        this.popupShow = true
      })
    },
    onBankInfoUpdateOk() {
      this.bankInfoUpdateShow = false
      this.goToEditBankAccount()
    },
    goToEditBankAccount() {
      const current = this.selectWithdrawMethod || {}
      const bankMethod =
        current.withdrawType === 3
          ? current
          : (this.withdrawMethods || []).find((item) => item.withdrawType === 3)
      if (!bankMethod || !bankMethod.account) {
        this.goToBindAccount(3)
        return
      }
      this.$router.push({
        name: 'EditBankAccount',
        query: { ...this.$route.query, redirect: 'Withdrawal' },
        params: {
          account: bankMethod.account,
          documentId: bankMethod.documentId,
          city: bankMethod.param ? bankMethod.param.city : undefined,
          postalCode: bankMethod.param ? bankMethod.param.postalCode : undefined,
          addressLine: bankMethod.param ? bankMethod.param.addressLine1 : undefined,
          bankType: bankMethod.bankType,
          withdrawType: bankMethod.withdrawType,
          withdrawId: bankMethod.withdrawId
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home_page {
  width: 100%;
  background-color: #efefef;
  position: relative;
  height: 100%;
}

.balance_des_menu {
  box-sizing: border-box;
  padding: 0 0.16rem;
}

.balance_des_item,
.linked_wrapper {
  display: flex;
  flex-direction: column;
  margin-top: 0.12rem;
  width: 100%;
  border-bottom: 1px solid #eeeef7;
  min-height: 0.6rem;
  position: relative;
  background-color: #fff;
  padding: 0 0.16rem;
  border-radius: 0.16rem;
  text-align: left;
  -webkit-tap-highlight-color: transparent;
}

.fee {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 0.6rem;
  min-height: 0.6rem;
  box-sizing: border-box;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

.balance_des_item .balance_title,
.linked_wrapper .link_title {
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.2rem;
  padding: 0.12rem 0;
  border-bottom: 0.01rem solid #e4e4e4;
}

.item_content {
  position: relative;
  padding: 0.07rem 0;
  gap: 0.12rem;
  min-height: 0.6rem;
}

.no_available_note {
  display: flex;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 600;
  height: 0.5rem;
  align-items: center;
}

.balance_err_text {
  font-size: 0.12rem;
  line-height: 0.2rem;
  min-height: 0.2rem;
  margin-top: 0.12rem;
  display: flex;
  align-items: center;
  position: relative;
  color: #ff4c62;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

.balance_des_item_hd {
  color: #282828;
  font-size: 0.16rem;
  font-weight: 600;
  line-height: 0.22rem;
  user-select: none;
}

.balance_des_item_hd.flex0 {
  flex: 0;
}

.balance_des_item_ft.flex1 {
  flex: 1;
}

.balance_des_item_hd_img i,
.balance_des_item_hd_img .channel_icon,
.select_account_logo i,
.select_account_logo .channel_icon {
  width: 0.36rem;
  height: 0.28rem;
  display: block;
  object-fit: contain;
}

.balance_des_item_ft_img {
  width: 0.1rem;
  height: 0.1rem;

  &.mirror {
    transform: rotate(180deg);
  }
}

.balance_des_item_span {
  color: #aeaeae;
  font-size: 0.14rem;
  line-height: 0.22rem;
  margin-inline-start: 5px;
  text-align: right;
  white-space: nowrap;
}

.select_text,
.account_info {
  margin-inline-start: 0.16rem;
  color: #282828;
  font-size: 0.16rem;
  display: flex;
  flex-direction: column;
  gap: 0.02rem;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  line-height: 0.24rem;
}

.select_text_account,
.account {
  color: #828282;
  font-size: 0.12rem;
}

.input_text {
  box-sizing: border-box;
  flex: 1;
  min-width: 0;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.36rem !important;
  line-height: 0.44rem !important;
  height: 0.44rem;
  min-height: 0.44rem;
  text-align: start;
  background: none;
  outline: none;
  border: none;
  padding: 0 !important;
}

.clear {
  width: 0.2rem;
  height: 0.2rem;
  margin-inline-start: auto;
  flex-shrink: 0;
}

input {
  background: none;
  outline: none;
  border: 1px solid #ccc;
  margin: 0;
  color: #282828;
}

input:focus {
  border: none;
}

input::-webkit-input-placeholder {
  color: #bfbfbf;
  font-size: 0.16rem;
  line-height: 0.44rem;
}

.cash_out_btn {
  margin: 0.18rem;
  font-size: 0.16rem;
  color: #ffffff;
  font-weight: bold;
  height: 0.5rem;
  line-height: 0.5rem;
  border-radius: 0.365rem;
  background: #378e5b;
  user-select: none;
}

.cash_out_btn.disabled {
  background: #378e5b80;
}

.icon_bank_card {
  background: url('../assets/channels/property_1_.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_gcash {
  background: url('../assets/channels/property_1_gcash.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_go_pay {
  background: url('../assets/channels/property_1_gopay.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_ovo {
  background: url('../assets/channels/property_1_ovo.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_dana {
  background: url('../assets/channels/property_1_dana.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_payapal {
  background: url('../assets/channels/property_1_paypal.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_epay {
  background: url('../assets/channels/property_1_epay.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.new_icon_payapal {
  background: url('../assets/new_paypal_logo.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.new_icon_imps {
  background: url('../assets/channels/property_1_imps.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_upi {
  background: url('../assets/channels/property_1_upi.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_jazz_cash {
  background: url('../assets/channels/property_1_jazz_cash.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_easy_paisa {
  background: url('../assets/channels/property_1_easypaisa.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.usdt_epay {
  background: url('../assets/channels/property_1_usdt.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_e_wallet::after {
  content: 'Mobile Money';
  display: flex;
  width: 200%;
  height: 100%;
  color: #378e5b;
  font-size: 0.18rem;
  justify-content: start;
  align-items: center;
  font-weight: 900;
}

.icon_qiwi {
  background: url('../assets/channels/property_1_qiwi.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.link_account_area {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.18rem;
  position: relative;
  overflow-y: scroll;
  max-height: 4rem;
}

.link_account_item {
  width: 100%;
  height: 0.6rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  font-size: 0;
  border-bottom: 1px solid #eeeef7;
}

.link_account_item_space {
  justify-content: space-between;
}

.select_account_logo i,
.select_account_logo .channel_icon {
  width: 0.36rem;
  height: 0.28rem;
  display: block;
  object-fit: contain;
}

.select_account {
  flex: auto;
  color: #252525;
  font-size: 0.16rem;
  text-align: right;
}

.select_account_arrow {
  flex: none;
  box-sizing: border-box;
  margin-inline-start: 0.12rem;
}

.select_account_arrow_img {
  width: 0.24rem;
  height: 0.24rem;
  background: url('../assets/arrow_right.png') no-repeat center;
  background-size: 0.12rem;
  display: block;
}

.title_wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.title_wrapper.title_mirror {
  flex-direction: row-reverse;
}

.title_wrapper .title_text {
  font-size: 0.2rem;
  font-weight: 600;
  line-height: 0.28rem;
  color: #2f2f2f;
  max-width: calc(100% - 0.4rem);
  text-align: start;
}

.balance_des_tip {
  text-align: start;
  margin-top: 0.12rem;
  font-size: 0.12rem;
  line-height: 0.2rem;
  min-height: 0.2rem;
  height: auto;
  color: #ff4c62;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

.add_btn {
  flex: none;
  font-size: 0.12rem;
  height: 0.24rem;
  padding: 0.02rem 0.08rem;
  background: linear-gradient(90deg, #43d77d 0%, #3fbb70 100%), rgba(0, 0, 0, 0.9);
  border-radius: 0.04rem;
  color: #fff;
  font-weight: 600;
  line-height: 0.2rem;
}

.account_picker_popup.van-popup {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: transparent;
}

.account_popup {
  overflow: hidden;
  padding: 0.24rem 0.16rem;
  background: #efefef;
  border-radius: 0.16rem 0.16rem 0 0;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  box-sizing: border-box;
  width: 100%;
  max-height: inherit;
  min-height: 0;
}

.account_popup .title_wrapper {
  flex-shrink: 0;
}

.account_popup_scroll {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.account_popup .linked_wrapper {
  margin-top: 0;
  flex-shrink: 0;
}
.edit_btn {
  height: 0.24rem;
  padding: 0px 0.08rem;
  border-radius: 0.04rem;
  background: rgba(63, 187, 112, 0.1);
  color: #3fbb70;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.24rem;
}

.checkbox_label {
  position: absolute;
  top: 0.07rem;
  right: 0;
  height: 0.14rem;
  width: 0.14rem;
}

.input_amount_wrapper {
  color: #2f2f2f;
  padding-bottom: 0.12rem;
  font-family: 'PingFang SC';
  font-size: 0.36rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.44rem;
  min-height: 0.44rem;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 0.01rem solid #efefef;
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
  user-select: none;
  cursor: text;
  background: transparent;
}

.input_amount_wrapper:active,
.input_amount_wrapper.focused {
  background: transparent;
}

.amount_currency {
  flex-shrink: 0;
  color: #2f2f2f;
}

.amount_value {
  color: #2f2f2f;
  font-size: 0.36rem;
  line-height: 0.44rem;
  font-weight: 600;
  direction: ltr;
}

.amount_placeholder {
  flex: 1;
  min-width: 0;
  color: #bfbfbf;
  font-size: 0.16rem;
  font-weight: 400;
  line-height: 0.44rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;
}

.amount_caret {
  width: 0.02rem;
  height: 0.36rem;
  margin-inline-start: 0.02rem;
  background: #3fbb70;
  border-radius: 0.01rem;
  flex-shrink: 0;
  animation: amount-caret-blink 1s step-end infinite;
}

@keyframes amount-caret-blink {
  50% {
    opacity: 0;
  }
}

.balance_title.border_none {
  border-bottom: none;
}

.Withdrawable {
  height: 0.44rem;
  color: #b5aec0;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.12rem;
  align-items: center;
}

.balance_des_item_span_all {
  color: #3fbb70;
}

.next_btn {
  width: 100% !important;
  margin-top: 0.12rem;
  font-size: 0.16rem !important;
}

.add_btn.add_mirror {
  left: 0.24rem;
  right: auto;
}

.checkbox_label.check_mirror {
  left: 0;
  right: auto;
}
</style>

<style>
.home_page .van-cell::after {
  content: unset;
}

.home_page .van-cell__value--alone {
  align-items: end;
  justify-content: end;
}

.payment-dialog.van-dialog {
  top: 30%;
}

.channel_unavailable_popup.van-popup {
  width: 100%;
  background: transparent;
  overflow: hidden;
  /* 用 CSS 抬层，不要写 van-popup 的 z-index prop，否则会重置 Vant 全局计数 */
  z-index: 4000 !important;
}

.channel_unavailable_card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.18rem;
  padding: 0.36rem 0.24rem 0.48rem;
  box-sizing: border-box;
  width: 100%;
  border-radius: 0.24rem 0.24rem 0 0;
  background: linear-gradient(111.3deg, #f8f4e3 3.03%, #e7fff3 83.05%);
}

.channel_unavailable_texts {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.12rem;
  width: 100%;
  text-align: center;
}

.channel_unavailable_title {
  width: 100%;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.18rem;
  font-weight: 600;
  line-height: 0.26rem;
  word-break: break-word;
}

.channel_unavailable_note {
  width: 100%;
  color: #5b5b5b;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-weight: 400;
  line-height: 0.24rem;
  word-break: break-word;
}

.channel_unavailable_ok {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.13rem 0.24rem;
  border-radius: 0.08rem;
  background: linear-gradient(90deg, #43d77d 0%, #3fbb70 100%), rgba(0, 0, 0, 0.9);
  color: #fff;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-weight: 600;
  line-height: 0.24rem;
  text-align: center;
  height: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Withdrawal.vue